// Cloud Consulting Services content
export const consultServices = [
  {
    id: 'strategy',
    title: 'Cloud Strategy & Advisory',
    icon: 'Compass',
    tagline: 'Align technology investments with your business objectives.',
    features: [
      'Cloud readiness assessment',
      'Digital transformation consulting',
      'Cloud adoption strategy',
      'Business case development',
      'Technology roadmap',
      'Cloud governance framework',
      'Executive workshops',
      'IT modernization planning'
    ]
  },
  {
    id: 'architecture',
    title: 'Cloud Architecture & Design',
    icon: 'Layers',
    tagline: 'Secure, scalable, high-performing environments by design.',
    features: [
      'Cloud architecture design',
      'Landing zone implementation',
      'Hybrid cloud architecture',
      'Multi-cloud strategy',
      'High availability architecture',
      'Disaster recovery design',
      'Network architecture',
      'Identity & access management'
    ]
  },
  {
    id: 'migration',
    title: 'Cloud Migration Consulting',
    icon: 'CloudUpload',
    tagline: 'Move with minimal risk and business disruption.',
    features: [
      'Application migration',
      'Database migration',
      'VMware migration',
      'Data center migration',
      'Storage migration',
      'Migration planning & assessment',
      'Migration execution',
      'Post-migration optimization'
    ]
  },
  {
    id: 'security',
    title: 'Cloud Security & Governance',
    icon: 'ShieldCheck',
    tagline: 'Enterprise-grade security and governance from day one.',
    features: [
      'Cloud security assessments',
      'Identity & access management',
      'Zero Trust architecture',
      'Security posture reviews',
      'Compliance consulting',
      'Cloud governance',
      'Risk assessments',
      'Backup & disaster recovery'
    ]
  },
  {
    id: 'finops',
    title: 'Cloud Cost Optimization (FinOps)',
    icon: 'PiggyBank',
    tagline: 'Predictable cloud spend without compromising performance.',
    features: [
      'Cloud cost assessments',
      'Resource rightsizing',
      'Reserved instance planning',
      'Savings Plans optimization',
      'Cost monitoring dashboards',
      'Budget forecasting',
      'Cloud financial governance',
      'Continuous optimization'
    ]
  },
  {
    id: 'managed-advisory',
    title: 'Managed Cloud Advisory',
    icon: 'LifeBuoy',
    tagline: 'Continuous guidance beyond the initial migration.',
    features: [
      'Performance improvement reviews',
      'Security posture optimization',
      'Compliance monitoring',
      'Operational efficiency reviews',
      'Ongoing architecture guidance',
      'Roadmap refinement'
    ]
  }
];

export const consultProcess = [
  { step: '01', title: 'Discover', description: 'Understand your business objectives, IT landscape, operational challenges, and long-term growth plans.' },
  { step: '02', title: 'Assess', description: 'Evaluate applications, infrastructure, security posture, workloads, and cloud readiness.' },
  { step: '03', title: 'Design', description: 'Create a customized cloud strategy and architecture tailored to your business requirements.' },
  { step: '04', title: 'Implement', description: 'Execute migrations, deploy cloud-native solutions, and modernize your environment with your teams.' },
  { step: '05', title: 'Optimize', description: 'Continuously improve performance, security, governance, reliability, and costs to maximize ROI.' }
];

export const consultBenefits = [
  { title: 'Accelerate digital transformation', icon: 'Rocket' },
  { title: 'Reduce infrastructure & ops costs', icon: 'PiggyBank' },
  { title: 'Improve agility & scalability', icon: 'TrendingUp' },
  { title: 'Strengthen security & compliance', icon: 'ShieldCheck' },
  { title: 'Increase performance & availability', icon: 'Gauge' },
  { title: 'Simplify IT with automation', icon: 'Workflow' },
  { title: 'Enhance disaster recovery & BC', icon: 'LifeBuoy' },
  { title: 'Optimize spend with FinOps', icon: 'Wallet' },
  { title: 'Enable AI & analytics initiatives', icon: 'Brain' },
  { title: 'Build future-ready foundations', icon: 'Sparkles' }
];

export const consultWhyPartner = [
  { title: 'Certified Cloud Experts', description: 'Deep expertise across architecture, migration, modernization, security, and optimization.', icon: 'BadgeCheck' },
  { title: 'Business-Driven Solutions', description: 'Every recommendation aligned with your business goals for measurable value.', icon: 'Target' },
  { title: 'AWS Partner Advantage', description: 'Proven methodologies and best practices from the AWS Partner Network.', icon: 'Award' },
  { title: 'End-to-End Cloud Expertise', description: 'Strategy → architecture → migration → modernization → managed services → optimization.', icon: 'GitBranch' },
  { title: 'Security & Compliance First', description: 'Enterprise-grade security, governance, resilience, and compliance at the core.', icon: 'Lock' }
];

export const consultTech = [
  'AWS', 'Microsoft Azure', 'Google Cloud (GCP)', 'VMware', 'Kubernetes', 'Docker',
  'Terraform', 'AWS CloudFormation', 'Amazon EC2', 'Amazon S3', 'Amazon RDS',
  'Amazon ECS & EKS', 'AWS Lambda', 'Amazon Bedrock', 'Amazon SageMaker',
  'CloudWatch', 'GitHub Actions', 'Jenkins', 'Prometheus', 'Grafana'
];

export const consultIndustries = [
  { name: 'Retail & FMCG', icon: 'ShoppingBag' },
  { name: 'Banking & Financial Services', icon: 'Landmark' },
  { name: 'Real Estate & Construction', icon: 'Building2' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Hospitality', icon: 'Hotel' },
  { name: 'Logistics & Supply Chain', icon: 'Truck' },
  { name: 'Government', icon: 'Landmark' },
  { name: 'Education', icon: 'GraduationCap' },
  { name: 'Media & Entertainment', icon: 'Film' }
];

export const consultFaqs = [
  { q: 'What are Cloud Consulting Services?', a: 'Cloud consulting helps organizations plan, design, implement, secure, optimize, and manage cloud environments to improve business performance and accelerate digital transformation.' },
  { q: 'Which cloud platform is best for my business?', a: 'The right platform depends on your workloads, business goals, compliance requirements, and existing technology investments. Our consultants help you select the most suitable cloud strategy based on your specific needs.' },
  { q: 'Can you help optimize our existing cloud environment?', a: 'Yes. We specialize in cloud optimization, performance tuning, security improvements, governance, and FinOps to ensure you get maximum value from your cloud investment.' },
  { q: 'Do you support hybrid and multi-cloud environments?', a: 'Absolutely. We design, implement, and manage hybrid and multi-cloud architectures that provide flexibility, resilience, and business continuity.' }
];
